import { render } from "./Head2Head.vue?vue&type=template&id=9398058e"
import script from "./Head2Head.vue?vue&type=script&lang=js"
export * from "./Head2Head.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\diloti\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__